import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './DetailsMembers.css';
import { getMembers } from 'selectors/admin/work-orders/details/details';
import { formatPhoneNumber } from 'services/utils/text-util';
import SimpleTable from 'components/shared/table/SimpleTable';
import AddMemberModal from 'components/admin/work-orders/details/members/AddMemberModal';
import ContractorStatus from 'components/admin/contractors/ContractorStatus';
import { getCurrentUser } from 'selectors/authentication';
import { ROLES, TYPES, usersUtil } from 'services/utils/users-util';
import Button from 'components/shared/button/Button';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import { deleteMember } from 'actions/admin/work-orders/details/members';

class DetailsMembers extends Component {
  static propTypes = {
    currentUser: PropTypes.shape({}).isRequired,
    members: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    onMemberDelete: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    const { currentUser } = props;
    this.showDelete =
      usersUtil.hasType(currentUser, TYPES.CONTRACTOR) &&
      (usersUtil.hasRole(currentUser, ROLES.OWNER) ||
        usersUtil.hasRole(currentUser, ROLES.CONTRACTOR_PROJECT_MANAGER));
    this.state = {
      memberIdToDelete: null,
      showDeleteConfirmation: false,
    };
  }

  handleDeleteConfirmation = (response) => {
    if (response) {
      this.props.onMemberDelete(this.state.memberIdToDelete);
    }
    this.setState({
      memberIdToDelete: null,
      showDeleteConfirmation: false,
    });
  };

  render() {
    const { members } = this.props;
    const classNames = ['members-table'];
    const headers = ['NAME', 'EMAIL', 'PHONE NUMBER', 'STATUS'];
    if (this.showDelete) {
      classNames.push('for-contractor');
      headers.push('');
    }
    return (
      <div className="details-members">
        <SimpleTable
          className={classNames.join(' ')}
          headers={headers}
          rows={this.mapMembers(members)}
          emptyMessage="No Members"
        />
        <AddMemberModal />
        <ConfirmationModal
          show={this.state.showDeleteConfirmation}
          message="Are you sure you want to delete the member?"
          onHide={this.handleDeleteConfirmation}
        />
      </div>
    );
  }

  mapMembers(members) {
    return members.map((member) => {
      const rows = [
        `${member.user.first_name} ${member.user.last_name}`,
        <span className="mailto">{member.user.email}</span>,
        member.user.phone_number !== null
          ? formatPhoneNumber(member.user.phone_number)
          : 'N/A',
        <ContractorStatus status={member.user.status} />,
      ];
      if (this.showDelete) {
        if (usersUtil.hasType(member.user, TYPES.CONTRACTOR)) {
          rows.push(
            <Button
              className="button-blue-grey"
              label="Delete"
              onClick={() =>
                this.setState({
                  memberIdToDelete: member.id,
                  showDeleteConfirmation: true,
                })
              }
            />
          );
        } else {
          rows.push(<div />);
        }
      }
      return rows;
    });
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: getCurrentUser(state),
    members: getMembers(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onMemberDelete: (memberId) => {
    dispatch(deleteMember(memberId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DetailsMembers);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/DetailsMembers.js